module.exports = __webpack_public_path__ + "img/e4_img5.1228b4e.webp";